// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__wCvyJ","imglogo":"Home_imglogo__O_dRp","linkblock":"Home_linkblock__1y3Zd","link":"Home_link__3R3wF","max":"Home_max__2S-Sd"};